/* NuzzleSip — interaction layer. Transform/opacity only. ~5KB. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var isReduced = function () { return reduced.matches; };

  /* ---------- 1. Scroll reveal ---------------------------------------- */
  function initReveal() {
    var nodes = document.querySelectorAll('[data-ns-reveal]:not(.is-in)');
    if (!nodes.length) return;
    if (isReduced() || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var group = el.closest('[data-ns-stagger]');
        if (group) {
          var sibs = Array.prototype.slice.call(group.querySelectorAll('[data-ns-reveal]'));
          var i = sibs.indexOf(el);
          if (i > -1) el.style.setProperty('--ns-delay', Math.min(i, 8) * 70 + 'ms');
        }
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ---------- 2. Parallax (rAF, transform only) ----------------------- */
  var parallaxNodes = [];
  var ticking = false;

  function collectParallax() {
    parallaxNodes = Array.prototype.slice.call(document.querySelectorAll('[data-ns-parallax]'));
  }

  function runParallax() {
    ticking = false;
    if (isReduced()) return;
    var vh = window.innerHeight;
    for (var i = 0; i < parallaxNodes.length; i++) {
      var el = parallaxNodes[i];
      var rect = el.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) continue;
      var speed = parseFloat(el.getAttribute('data-ns-parallax')) || 0.12;
      var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
      var shift = Math.max(-40, Math.min(40, -progress * speed * 100));
      el.style.transform = 'translate3d(0,' + shift.toFixed(2) + 'px,0)';
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(runParallax);
    }
    var scrolled = window.scrollY > 12;
    if (scrolled !== document.body.classList.contains('ns-scrolled')) {
      document.body.classList.toggle('ns-scrolled', scrolled);
    }
  }

  /* ---------- 3. How-it-works active step ----------------------------- */
  function initSteps() {
    var lists = document.querySelectorAll('[data-ns-steps]');
    if (!lists.length || !('IntersectionObserver' in window)) return;
    lists.forEach(function (list) {
      var steps = Array.prototype.slice.call(list.querySelectorAll('.ns-step'));
      if (!steps.length) return;
      if (isReduced()) { steps.forEach(function (s) { s.classList.add('is-active'); }); return; }
      steps[0].classList.add('is-active');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            steps.forEach(function (s) { s.classList.remove('is-active'); });
            e.target.classList.add('is-active');
          }
        });
      }, { rootMargin: '-42% 0px -42% 0px', threshold: 0 });
      steps.forEach(function (s) { io.observe(s); });
    });
  }

  /* ---------- 4. Mobile sticky buy bar -------------------------------- */
  function initBuyBar() {
    var host = document.querySelector('[data-ns-buybar]');
    if (!host) return;
    var anchor = document.querySelector('add-to-cart-component') ||
                 document.querySelector('.add-to-cart-button');
    if (!anchor) { host.remove(); return; }

    var realBtn = anchor.querySelector('button, [type="submit"]') ||
                  (anchor.matches('button') ? anchor : null);

    var btn = host.querySelector('[data-ns-buybar-cta]');
    if (btn && realBtn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        realBtn.click();
      });
    }

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        host.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);
    document.body.classList.add('ns-has-buybar');
  }

  /* ---------- 5. Accordion: one open at a time ------------------------ */
  function initFaq() {
    document.querySelectorAll('[data-ns-faq]').forEach(function (group) {
      var items = Array.prototype.slice.call(group.querySelectorAll('details.ns-faq__item'));
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) { if (other !== item) other.open = false; });
        });
      });
    });
  }

  /* ---------- 6. Cart drawer cross-sell ------------------------------- */
  function crossSellMarkup(d) {
    return '<div class="ns-drawer-cross" data-ns-drawer-cross>' +
      '<div class="ns-drawer-cross__media"><img src="' + d.image + '" alt="" width="120" height="120" loading="lazy"></div>' +
      '<div class="ns-drawer-cross__body">' +
        '<div class="ns-drawer-cross__label">Keep it fresh</div>' +
        '<div class="ns-drawer-cross__title">' + d.title + '</div>' +
        '<div class="ns-drawer-cross__price">' + d.price + '</div>' +
      '</div>' +
      '<button type="button" class="ns-drawer-cross__add" data-ns-add="' + d.id + '">Add</button>' +
    '</div>';
  }

  function initDrawerCrossSell() {
    var tag = document.getElementById('ns-crosssell-data');
    if (!tag) return;
    var data;
    try { data = JSON.parse(tag.textContent); } catch (err) { return; }
    if (!data || !data.id) return;

    function inject() {
      var drawer = document.querySelector('cart-drawer-component');
      if (!drawer) return;
      var card = drawer.querySelector('[data-ns-drawer-cross]');
      var rows = Array.prototype.slice.call(drawer.querySelectorAll('[data-ns-product-id]'));
      var productIds = rows.map(function (row) { return String(row.getAttribute('data-ns-product-id')); });
      var hasFountain = productIds.indexOf(String(data.fountainProductId)) > -1;
      var hasFilters = productIds.indexOf(String(data.filterProductId)) > -1;
      if (!hasFountain || hasFilters) {
        if (card) card.remove();
        return;
      }
      if (card) return;
      var anchor = drawer.querySelector('.cart-drawer__summary');
      var items = drawer.querySelector('.cart-drawer__items') ||
                  drawer.querySelector('cart-items-component, .cart-items, [class*="cart-items"]');
      if (!anchor && !items) return;
      var holder = document.createElement('div');
      holder.innerHTML = crossSellMarkup(data);
      card = holder.firstElementChild;
      if (anchor) anchor.insertAdjacentElement('beforebegin', card);
      else items.insertAdjacentElement('afterend', card);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-ns-add]') : null;
      if (!btn) return;
      e.preventDefault();
      btn.disabled = true;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-ns-add')), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        btn.textContent = 'Added';
        window.setTimeout(function () { window.location.reload(); }, 350);
      }).catch(function () {
        window.location.href = '/products/' + data.handle;
      });
    });

    var mo = new MutationObserver(function () { inject(); });
    var target = document.querySelector('cart-drawer-component') || document.body;
    mo.observe(target, { childList: true, subtree: true });
    inject();
  }

  /* ---------- 7. Autoplay control for hero video ---------------------- */
  function initVideos() {
    document.querySelectorAll('video[data-ns-video], .ns-hero__media video, .ns-steps__visual video, .ns-feature__media video').forEach(function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
      if (isReduced()) { v.removeAttribute('autoplay'); v.pause(); return; }
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.15 });
      io.observe(v);
    });
  }

  /* ---------- boot ---------------------------------------------------- */
  function boot() {
    document.documentElement.classList.remove('no-js');
    initReveal();
    collectParallax();
    initSteps();
    initBuyBar();
    initFaq();
    initDrawerCrossSell();
    initVideos();
    runParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { collectParallax(); runParallax(); }, { passive: true });

  /* Shopify theme editor: re-init on section render */
  document.addEventListener('shopify:section:load', function () {
    initReveal(); collectParallax(); initSteps(); initBuyBar(); initFaq(); initVideos();
  });
})();
